import React, { memo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SideCart from "./../../pages/SideCart";
import useCart from "../../hooks/useCart";
import { useAuth } from "../../hooks/useAuth";
import { useMediaQuery } from "@react-hook/media-query";
import { whatsapp_links } from "../../util/whatsapp";
import MobileMenu from "../MobileMenu";

const MainNavbar = () => {
  const { isLoggedIn, userInfo } = useAuth();

  const { cart } = useCart();

  function totalCartProducts() {

    var totalProducts = 0;

    for (let i = 0; i < cart.length; i++) {
      totalProducts += cart[i].quantity;
    };

    return totalProducts;
  };

  const { logout } = useAuth();

  const publicUrl = process.env.PUBLIC_URL + "/";
  const logoUrl = `${publicUrl}assets/img/logo.png`;

  const isSmallScreen = useMediaQuery("(max-width: 431px)");
  const isMediumScreen = useMediaQuery("(max-width: 1180px)");

  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const whatsappLink = whatsapp_links.geral;

  // Implementa o sticky header
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsSticky(scrollTop > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappButton = () => {
    window.open(whatsappLink, "_blank");
  };

  const confirmLogout = () => {
    if (window.confirm("Você realmente deseja sair da sua conta?")) {
      logout();
    }
  };

  const handleOpenMobileMenu = () => {
    setOpenMobileMenu(true);
  };

  const handleCloseMobileMenu = () => {
    setOpenMobileMenu(false);
  };

  const handleOpenCart = () => {
    setOpenCart(true);
  };
  const handleCloseCart = () => {
    setOpenCart(false);
  };


  return (
    <div>
      <header className="ltn__header-area ltn__header-5 ltn__header-transparent--- gradient-color-4---">
        <div className={`ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white ${isSticky ? "sticky-active" : ""}`}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-6 col-lg-3">
                <div className="site-logo-wrap">
                  <div
                    className="site-logo go-top"
                    style={{
                      marginRight: isMediumScreen && !isSmallScreen && "100px",
                    }}
                  >
                    <Link to="/" title="Página inicial">
                      <img src={logoUrl} alt="Logo" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-6">
                <div className="ltn__header-options ltn__header-options-2 mb-sm-20 m-0 justify-content-end">
                  <div className="header-menu">
                    <nav>
                      <div className="ltn__main-menu go-top">
                        <ul className="justify-content-end">
                          {!isMediumScreen && (
                            <>
                              <li>
                                <Link to="/" title="Página inicial">
                                  Página Inicial
                                </Link>
                              </li>
                              <li>
                                <Link to="/produtos" title="Produtos">
                                  Produtos
                                </Link>
                              </li>
                              <li>
                                <Link to="/videos" title="Vídeos">
                                  Vídeos
                                </Link>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    </nav>
                  </div>
                  <div className="col-6 col-lg-3">
                    <div className="ltn__header-options ltn__header-options-2 mb-sm-20 m-0 justify-content-end">
                      {!isMediumScreen && (
                        <>
                          <Link
                            to={
                              isLoggedIn
                                ? userInfo?.is_user_terra
                                  ? "/meus-clientes"
                                  : "/minha-conta/perfil"
                                : "/autenticacao"
                            }
                            title={
                              isLoggedIn
                                ? userInfo?.is_user_terra
                                  ? "Meus clientes"
                                  : "Minha conta"
                                : "Login"
                            }
                          >
                            <button
                              className={`theme-btn-4 btn btn-effect-1  ${isLoggedIn && "ltn__drop-menu"
                                } user-menu`}
                              title={isLoggedIn ? "Minha conta" : "Login"}
                              type="button"
                              style={{
                                boxShadow: "var(--ltn__box-shadow-1)",
                                border: "none",
                                padding: "12px 16px",
                                marginRight: "8px",
                                minWidth: isLoggedIn ? "50px" : "100px",
                              }}
                            >
                              {isLoggedIn ? (
                                <i className="icon-user" />
                              ) : (
                                <>
                                  <i className="fa-regular fa-right-to-bracket"></i>{" "}
                                  Login
                                </>
                              )}
                            </button>
                          </Link>
                        </>
                      )}
                      {isMediumScreen && !isSmallScreen && (
                        <button
                          className="theme-btn-4 btn btn-effect-1"
                          style={{
                            boxShadow: "var(--ltn__box-shadow-1)",
                            border: "none",
                            padding: "12px 16px",
                          }}
                          onClick={whatsappButton}
                          aria-label="Abrir WhatsApp"
                          title="Abrir WhatsApp"
                          type="button"
                        >
                          <i
                            className="fa-brands fa-whatsapp"
                            style={{ margin: 0 }}
                            aria-hidden="true"
                          ></i>
                        </button>
                      )}
                      {isLoggedIn && (
                        <button
                          className="theme-btn-4 btn btn-effect-1"
                          style={{
                            boxShadow: "var(--ltn__box-shadow-1)",
                            border: "none",
                            padding: "12px 16px",
                          }}
                          onClick={handleOpenCart}
                          title="Abrir carrinho"
                          type="button"
                        >
                          <i className="icon-shopping-cart"></i>
                          {cart.length !== 0 && isLoggedIn && (
                            <sup>{totalCartProducts()}</sup>
                          )}
                        </button>
                      )}
                      {isLoggedIn &&
                        userInfo?.is_user_terra &&
                        isMediumScreen &&
                        !isSmallScreen && (
                          <Link to="/meus-clientes" title="Meus clientes">
                            <button
                              className="theme-btn-4 btn btn-effect-1"
                              title="Meus clientes"
                              type="button"
                              style={{
                                boxShadow: "var(--ltn__box-shadow-1)",
                                border: "none",
                                padding: "12px 16px",
                              }}
                            >
                              <i className="icon-user" />
                            </button>
                          </Link>
                        )}
                      {isLoggedIn &&
                        userInfo?.is_user_terra &&
                        isMediumScreen &&
                        !isSmallScreen && (
                          <Link to="/meus-clientes" title="Meus clientes — loja">
                            <button
                              className="theme-btn-4 btn btn-effect-1"
                              title="Meus clientes — loja"
                              type="button"
                              style={{
                                boxShadow: "var(--ltn__box-shadow-1)",
                                border: "none",
                                padding: "12px 16px",
                                marginLeft: "12px",
                              }}
                            >
                              <i className="fa-solid fa-shop"></i>
                            </button>
                          </Link>
                        )}
                    </div>
                  </div>

                  {!isMediumScreen && (
                    <>
                      {userInfo?.is_user_terra ? (
                        <button
                          className="theme-btn-1 btn btn-effect-1"
                          onClick={confirmLogout}
                          title="Sair"
                          type="button"
                          style={{
                            padding: "12px",
                            minWidth: "150px",
                            boxShadow: "var(--ltn__box-shadow-1)",
                            border: "none",
                          }}
                        >
                          <i className="fas fa-sign-out-alt" />
                          Sair
                        </button>
                      ) : (
                        <>
                          {isLoggedIn && (
                            <button
                              className="theme-btn-white btn btn-effect-1"
                              onClick={confirmLogout}
                              title="Sair da conta"
                              type="button"
                              style={{
                                padding: "14px 8px",
                                minWidth: "180px",
                                boxShadow: "var(--ltn__box-shadow-1)",
                                border: "none",
                              }}
                            >
                              <i className="fas fa-sign-out-alt" /> Sair da
                              conta
                            </button>
                          )}
                          <button
                            className="theme-btn-1 btn btn-effect-1"
                            style={{
                              padding: "14px 8px",
                              minWidth: "180px",
                              boxShadow: "var(--ltn__box-shadow-1)",
                              border: "none",
                            }}
                            onClick={whatsappButton}
                            aria-label="Abrir WhatsApp para entrar em contato"
                            title="Entre em contato pelo WhatsApp"
                            type="button"
                          >
                            <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
                            Entre em contato
                          </button>
                        </>
                      )}
                    </>
                  )}
                  {isMediumScreen && (
                    <>
                      {userInfo?.is_user_terra ? (
                        <button
                          className="theme-btn-1 btn btn-effect-1"
                          onClick={confirmLogout}
                          title="Sair"
                          type="button"
                          style={{
                            padding: "12px",
                            minWidth: "80px",
                            boxShadow: "var(--ltn__box-shadow-1)",
                            border: "none",
                          }}
                        >
                          <i className="fas fa-sign-out-alt" style={{}} />
                          Sair
                        </button>
                      ) : (
                        <button
                          className="theme-btn-1 btn btn-effect-1"
                          onClick={handleOpenMobileMenu}
                          title="Abrir menu"
                          type="button"
                          style={{
                            boxShadow: "var(--ltn__box-shadow-1)",
                            border: "none",
                            padding: "12px 16px",
                          }}
                        >
                          <i
                            className="fa-solid fa-bars"
                            style={{
                              margin: 0,
                            }}
                          />
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <SideCart handleCloseCart={handleCloseCart} isOpen={openCart} />

      <MobileMenu
        isOpen={openMobileMenu}
        onWhatsappButton={whatsappButton}
        handleCloseButton={handleCloseMobileMenu}
      />
    </div>
  );
};

export default memo(MainNavbar);
